/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as TestErrorsImport } from './routes/testErrors'
import { Route as PasswordlessImport } from './routes/passwordless'
import { Route as LoginImport } from './routes/login'
import { Route as EnrollImport } from './routes/enroll'
import { Route as ConciergeImport } from './routes/concierge'
import { Route as AuthenticatedImport } from './routes/_authenticated'
import { Route as IndexImport } from './routes/index'
import { Route as AuthenticatedWelcomeImport } from './routes/_authenticated/welcome'
import { Route as AuthenticatedHomeImport } from './routes/_authenticated/home'
import { Route as AuthenticatedPatientIdUploadFilesImport } from './routes/_authenticated/$patientId/upload/files'
import { Route as AuthenticatedPatientIdStatementRecordingImport } from './routes/_authenticated/$patientId/statement/recording'
import { Route as AuthenticatedPatientIdStatementFinalSignaturesImport } from './routes/_authenticated/$patientId/statement/finalSignatures'
import { Route as AuthenticatedPatientIdStatementAttestationImport } from './routes/_authenticated/$patientId/statement/attestation'
import { Route as AuthenticatedPatientIdPhotosQrInstructionsImport } from './routes/_authenticated/$patientId/photos/qrInstructions'
import { Route as AuthenticatedPatientIdPhotosPhotoForCardImport } from './routes/_authenticated/$patientId/photos/photoForCard'
import { Route as AuthenticatedPatientIdPhotosIdOnlyImport } from './routes/_authenticated/$patientId/photos/idOnly'
import { Route as AuthenticatedPatientIdPhotosIdConciergeImport } from './routes/_authenticated/$patientId/photos/idConcierge'
import { Route as AuthenticatedPatientIdPhotosIdImport } from './routes/_authenticated/$patientId/photos/id'
import { Route as AuthenticatedPatientIdPaymentThanksImport } from './routes/_authenticated/$patientId/payment/thanks'
import { Route as AuthenticatedPatientIdPaymentSelfPayImport } from './routes/_authenticated/$patientId/payment/selfPay'
import { Route as AuthenticatedPatientIdPaymentMedicareInfoImport } from './routes/_authenticated/$patientId/payment/medicareInfo'
import { Route as AuthenticatedPatientIdPaymentMedicareABNImport } from './routes/_authenticated/$patientId/payment/medicareABN'
import { Route as AuthenticatedPatientIdPaymentInsuranceInfoImport } from './routes/_authenticated/$patientId/payment/insuranceInfo'
import { Route as AuthenticatedPatientIdPaymentInsuranceABNImport } from './routes/_authenticated/$patientId/payment/insuranceABN'
import { Route as AuthenticatedPatientIdPaymentConfirmationImport } from './routes/_authenticated/$patientId/payment/confirmation'
import { Route as AuthenticatedPatientIdPaymentAobImport } from './routes/_authenticated/$patientId/payment/aob'
import { Route as AuthenticatedPatientIdPackageSelectImport } from './routes/_authenticated/$patientId/package/select'
import { Route as AuthenticatedPatientIdPackageLearnImport } from './routes/_authenticated/$patientId/package/learn'
import { Route as AuthenticatedPatientIdPackageConciergeImport } from './routes/_authenticated/$patientId/package/concierge'
import { Route as AuthenticatedPatientIdInfoPatientInfoImport } from './routes/_authenticated/$patientId/info/patientInfo'
import { Route as AuthenticatedPatientIdInfoHospitalInfoImport } from './routes/_authenticated/$patientId/info/hospitalInfo'
import { Route as AuthenticatedPatientIdInfoHcaInfoImport } from './routes/_authenticated/$patientId/info/hcaInfo'
import { Route as AuthenticatedPatientIdInfoDoctorInfoImport } from './routes/_authenticated/$patientId/info/doctorInfo'
import { Route as AuthenticatedPatientIdInfoCheckImport } from './routes/_authenticated/$patientId/info/check'
import { Route as AuthenticatedPatientIdInfoAttorneyInfoImport } from './routes/_authenticated/$patientId/info/attorneyInfo'
import { Route as AuthenticatedPatientIdEducationTreatmentOptionImport } from './routes/_authenticated/$patientId/education/treatmentOption'
import { Route as AuthenticatedPatientIdEducationPatientEducationImport } from './routes/_authenticated/$patientId/education/patientEducation'
import { Route as AuthenticatedPatientIdEducationInstructionalVideosImport } from './routes/_authenticated/$patientId/education/instructionalVideos'
import { Route as AuthenticatedPatientIdConsentFormsImport } from './routes/_authenticated/$patientId/consent/forms'
import { Route as AuthenticatedPatientIdCardLandingPageImport } from './routes/_authenticated/$patientId/card/landingPage'
import { Route as AuthenticatedPatientIdCardCardPreviewImport } from './routes/_authenticated/$patientId/card/cardPreview'
import { Route as AuthenticatedPatientIdCaptureIdImport } from './routes/_authenticated/$patientId/capture/id'
import { Route as AuthenticatedPatientIdAccountAccountInfoImport } from './routes/_authenticated/$patientId/account/accountInfo'

// Create/Update Routes

const TestErrorsRoute = TestErrorsImport.update({
  id: '/testErrors',
  path: '/testErrors',
  getParentRoute: () => rootRoute,
} as any)

const PasswordlessRoute = PasswordlessImport.update({
  id: '/passwordless',
  path: '/passwordless',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const EnrollRoute = EnrollImport.update({
  id: '/enroll',
  path: '/enroll',
  getParentRoute: () => rootRoute,
} as any)

const ConciergeRoute = ConciergeImport.update({
  id: '/concierge',
  path: '/concierge',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedRoute = AuthenticatedImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedWelcomeRoute = AuthenticatedWelcomeImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedHomeRoute = AuthenticatedHomeImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedPatientIdUploadFilesRoute =
  AuthenticatedPatientIdUploadFilesImport.update({
    id: '/$patientId/upload/files',
    path: '/$patientId/upload/files',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdStatementRecordingRoute =
  AuthenticatedPatientIdStatementRecordingImport.update({
    id: '/$patientId/statement/recording',
    path: '/$patientId/statement/recording',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdStatementFinalSignaturesRoute =
  AuthenticatedPatientIdStatementFinalSignaturesImport.update({
    id: '/$patientId/statement/finalSignatures',
    path: '/$patientId/statement/finalSignatures',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdStatementAttestationRoute =
  AuthenticatedPatientIdStatementAttestationImport.update({
    id: '/$patientId/statement/attestation',
    path: '/$patientId/statement/attestation',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdPhotosQrInstructionsRoute =
  AuthenticatedPatientIdPhotosQrInstructionsImport.update({
    id: '/$patientId/photos/qrInstructions',
    path: '/$patientId/photos/qrInstructions',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdPhotosPhotoForCardRoute =
  AuthenticatedPatientIdPhotosPhotoForCardImport.update({
    id: '/$patientId/photos/photoForCard',
    path: '/$patientId/photos/photoForCard',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdPhotosIdOnlyRoute =
  AuthenticatedPatientIdPhotosIdOnlyImport.update({
    id: '/$patientId/photos/idOnly',
    path: '/$patientId/photos/idOnly',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdPhotosIdConciergeRoute =
  AuthenticatedPatientIdPhotosIdConciergeImport.update({
    id: '/$patientId/photos/idConcierge',
    path: '/$patientId/photos/idConcierge',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdPhotosIdRoute =
  AuthenticatedPatientIdPhotosIdImport.update({
    id: '/$patientId/photos/id',
    path: '/$patientId/photos/id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdPaymentThanksRoute =
  AuthenticatedPatientIdPaymentThanksImport.update({
    id: '/$patientId/payment/thanks',
    path: '/$patientId/payment/thanks',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdPaymentSelfPayRoute =
  AuthenticatedPatientIdPaymentSelfPayImport.update({
    id: '/$patientId/payment/selfPay',
    path: '/$patientId/payment/selfPay',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdPaymentMedicareInfoRoute =
  AuthenticatedPatientIdPaymentMedicareInfoImport.update({
    id: '/$patientId/payment/medicareInfo',
    path: '/$patientId/payment/medicareInfo',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdPaymentMedicareABNRoute =
  AuthenticatedPatientIdPaymentMedicareABNImport.update({
    id: '/$patientId/payment/medicareABN',
    path: '/$patientId/payment/medicareABN',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdPaymentInsuranceInfoRoute =
  AuthenticatedPatientIdPaymentInsuranceInfoImport.update({
    id: '/$patientId/payment/insuranceInfo',
    path: '/$patientId/payment/insuranceInfo',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdPaymentInsuranceABNRoute =
  AuthenticatedPatientIdPaymentInsuranceABNImport.update({
    id: '/$patientId/payment/insuranceABN',
    path: '/$patientId/payment/insuranceABN',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdPaymentConfirmationRoute =
  AuthenticatedPatientIdPaymentConfirmationImport.update({
    id: '/$patientId/payment/confirmation',
    path: '/$patientId/payment/confirmation',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdPaymentAobRoute =
  AuthenticatedPatientIdPaymentAobImport.update({
    id: '/$patientId/payment/aob',
    path: '/$patientId/payment/aob',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdPackageSelectRoute =
  AuthenticatedPatientIdPackageSelectImport.update({
    id: '/$patientId/package/select',
    path: '/$patientId/package/select',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdPackageLearnRoute =
  AuthenticatedPatientIdPackageLearnImport.update({
    id: '/$patientId/package/learn',
    path: '/$patientId/package/learn',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdPackageConciergeRoute =
  AuthenticatedPatientIdPackageConciergeImport.update({
    id: '/$patientId/package/concierge',
    path: '/$patientId/package/concierge',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdInfoPatientInfoRoute =
  AuthenticatedPatientIdInfoPatientInfoImport.update({
    id: '/$patientId/info/patientInfo',
    path: '/$patientId/info/patientInfo',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdInfoHospitalInfoRoute =
  AuthenticatedPatientIdInfoHospitalInfoImport.update({
    id: '/$patientId/info/hospitalInfo',
    path: '/$patientId/info/hospitalInfo',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdInfoHcaInfoRoute =
  AuthenticatedPatientIdInfoHcaInfoImport.update({
    id: '/$patientId/info/hcaInfo',
    path: '/$patientId/info/hcaInfo',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdInfoDoctorInfoRoute =
  AuthenticatedPatientIdInfoDoctorInfoImport.update({
    id: '/$patientId/info/doctorInfo',
    path: '/$patientId/info/doctorInfo',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdInfoCheckRoute =
  AuthenticatedPatientIdInfoCheckImport.update({
    id: '/$patientId/info/check',
    path: '/$patientId/info/check',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdInfoAttorneyInfoRoute =
  AuthenticatedPatientIdInfoAttorneyInfoImport.update({
    id: '/$patientId/info/attorneyInfo',
    path: '/$patientId/info/attorneyInfo',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdEducationTreatmentOptionRoute =
  AuthenticatedPatientIdEducationTreatmentOptionImport.update({
    id: '/$patientId/education/treatmentOption',
    path: '/$patientId/education/treatmentOption',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdEducationPatientEducationRoute =
  AuthenticatedPatientIdEducationPatientEducationImport.update({
    id: '/$patientId/education/patientEducation',
    path: '/$patientId/education/patientEducation',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdEducationInstructionalVideosRoute =
  AuthenticatedPatientIdEducationInstructionalVideosImport.update({
    id: '/$patientId/education/instructionalVideos',
    path: '/$patientId/education/instructionalVideos',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdConsentFormsRoute =
  AuthenticatedPatientIdConsentFormsImport.update({
    id: '/$patientId/consent/forms',
    path: '/$patientId/consent/forms',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdCardLandingPageRoute =
  AuthenticatedPatientIdCardLandingPageImport.update({
    id: '/$patientId/card/landingPage',
    path: '/$patientId/card/landingPage',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdCardCardPreviewRoute =
  AuthenticatedPatientIdCardCardPreviewImport.update({
    id: '/$patientId/card/cardPreview',
    path: '/$patientId/card/cardPreview',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdCaptureIdRoute =
  AuthenticatedPatientIdCaptureIdImport.update({
    id: '/$patientId/capture/id',
    path: '/$patientId/capture/id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPatientIdAccountAccountInfoRoute =
  AuthenticatedPatientIdAccountAccountInfoImport.update({
    id: '/$patientId/account/accountInfo',
    path: '/$patientId/account/accountInfo',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedImport
      parentRoute: typeof rootRoute
    }
    '/concierge': {
      id: '/concierge'
      path: '/concierge'
      fullPath: '/concierge'
      preLoaderRoute: typeof ConciergeImport
      parentRoute: typeof rootRoute
    }
    '/enroll': {
      id: '/enroll'
      path: '/enroll'
      fullPath: '/enroll'
      preLoaderRoute: typeof EnrollImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/passwordless': {
      id: '/passwordless'
      path: '/passwordless'
      fullPath: '/passwordless'
      preLoaderRoute: typeof PasswordlessImport
      parentRoute: typeof rootRoute
    }
    '/testErrors': {
      id: '/testErrors'
      path: '/testErrors'
      fullPath: '/testErrors'
      preLoaderRoute: typeof TestErrorsImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/home': {
      id: '/_authenticated/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthenticatedHomeImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/welcome': {
      id: '/_authenticated/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof AuthenticatedWelcomeImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/account/accountInfo': {
      id: '/_authenticated/$patientId/account/accountInfo'
      path: '/$patientId/account/accountInfo'
      fullPath: '/$patientId/account/accountInfo'
      preLoaderRoute: typeof AuthenticatedPatientIdAccountAccountInfoImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/capture/id': {
      id: '/_authenticated/$patientId/capture/id'
      path: '/$patientId/capture/id'
      fullPath: '/$patientId/capture/id'
      preLoaderRoute: typeof AuthenticatedPatientIdCaptureIdImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/card/cardPreview': {
      id: '/_authenticated/$patientId/card/cardPreview'
      path: '/$patientId/card/cardPreview'
      fullPath: '/$patientId/card/cardPreview'
      preLoaderRoute: typeof AuthenticatedPatientIdCardCardPreviewImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/card/landingPage': {
      id: '/_authenticated/$patientId/card/landingPage'
      path: '/$patientId/card/landingPage'
      fullPath: '/$patientId/card/landingPage'
      preLoaderRoute: typeof AuthenticatedPatientIdCardLandingPageImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/consent/forms': {
      id: '/_authenticated/$patientId/consent/forms'
      path: '/$patientId/consent/forms'
      fullPath: '/$patientId/consent/forms'
      preLoaderRoute: typeof AuthenticatedPatientIdConsentFormsImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/education/instructionalVideos': {
      id: '/_authenticated/$patientId/education/instructionalVideos'
      path: '/$patientId/education/instructionalVideos'
      fullPath: '/$patientId/education/instructionalVideos'
      preLoaderRoute: typeof AuthenticatedPatientIdEducationInstructionalVideosImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/education/patientEducation': {
      id: '/_authenticated/$patientId/education/patientEducation'
      path: '/$patientId/education/patientEducation'
      fullPath: '/$patientId/education/patientEducation'
      preLoaderRoute: typeof AuthenticatedPatientIdEducationPatientEducationImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/education/treatmentOption': {
      id: '/_authenticated/$patientId/education/treatmentOption'
      path: '/$patientId/education/treatmentOption'
      fullPath: '/$patientId/education/treatmentOption'
      preLoaderRoute: typeof AuthenticatedPatientIdEducationTreatmentOptionImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/info/attorneyInfo': {
      id: '/_authenticated/$patientId/info/attorneyInfo'
      path: '/$patientId/info/attorneyInfo'
      fullPath: '/$patientId/info/attorneyInfo'
      preLoaderRoute: typeof AuthenticatedPatientIdInfoAttorneyInfoImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/info/check': {
      id: '/_authenticated/$patientId/info/check'
      path: '/$patientId/info/check'
      fullPath: '/$patientId/info/check'
      preLoaderRoute: typeof AuthenticatedPatientIdInfoCheckImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/info/doctorInfo': {
      id: '/_authenticated/$patientId/info/doctorInfo'
      path: '/$patientId/info/doctorInfo'
      fullPath: '/$patientId/info/doctorInfo'
      preLoaderRoute: typeof AuthenticatedPatientIdInfoDoctorInfoImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/info/hcaInfo': {
      id: '/_authenticated/$patientId/info/hcaInfo'
      path: '/$patientId/info/hcaInfo'
      fullPath: '/$patientId/info/hcaInfo'
      preLoaderRoute: typeof AuthenticatedPatientIdInfoHcaInfoImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/info/hospitalInfo': {
      id: '/_authenticated/$patientId/info/hospitalInfo'
      path: '/$patientId/info/hospitalInfo'
      fullPath: '/$patientId/info/hospitalInfo'
      preLoaderRoute: typeof AuthenticatedPatientIdInfoHospitalInfoImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/info/patientInfo': {
      id: '/_authenticated/$patientId/info/patientInfo'
      path: '/$patientId/info/patientInfo'
      fullPath: '/$patientId/info/patientInfo'
      preLoaderRoute: typeof AuthenticatedPatientIdInfoPatientInfoImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/package/concierge': {
      id: '/_authenticated/$patientId/package/concierge'
      path: '/$patientId/package/concierge'
      fullPath: '/$patientId/package/concierge'
      preLoaderRoute: typeof AuthenticatedPatientIdPackageConciergeImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/package/learn': {
      id: '/_authenticated/$patientId/package/learn'
      path: '/$patientId/package/learn'
      fullPath: '/$patientId/package/learn'
      preLoaderRoute: typeof AuthenticatedPatientIdPackageLearnImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/package/select': {
      id: '/_authenticated/$patientId/package/select'
      path: '/$patientId/package/select'
      fullPath: '/$patientId/package/select'
      preLoaderRoute: typeof AuthenticatedPatientIdPackageSelectImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/payment/aob': {
      id: '/_authenticated/$patientId/payment/aob'
      path: '/$patientId/payment/aob'
      fullPath: '/$patientId/payment/aob'
      preLoaderRoute: typeof AuthenticatedPatientIdPaymentAobImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/payment/confirmation': {
      id: '/_authenticated/$patientId/payment/confirmation'
      path: '/$patientId/payment/confirmation'
      fullPath: '/$patientId/payment/confirmation'
      preLoaderRoute: typeof AuthenticatedPatientIdPaymentConfirmationImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/payment/insuranceABN': {
      id: '/_authenticated/$patientId/payment/insuranceABN'
      path: '/$patientId/payment/insuranceABN'
      fullPath: '/$patientId/payment/insuranceABN'
      preLoaderRoute: typeof AuthenticatedPatientIdPaymentInsuranceABNImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/payment/insuranceInfo': {
      id: '/_authenticated/$patientId/payment/insuranceInfo'
      path: '/$patientId/payment/insuranceInfo'
      fullPath: '/$patientId/payment/insuranceInfo'
      preLoaderRoute: typeof AuthenticatedPatientIdPaymentInsuranceInfoImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/payment/medicareABN': {
      id: '/_authenticated/$patientId/payment/medicareABN'
      path: '/$patientId/payment/medicareABN'
      fullPath: '/$patientId/payment/medicareABN'
      preLoaderRoute: typeof AuthenticatedPatientIdPaymentMedicareABNImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/payment/medicareInfo': {
      id: '/_authenticated/$patientId/payment/medicareInfo'
      path: '/$patientId/payment/medicareInfo'
      fullPath: '/$patientId/payment/medicareInfo'
      preLoaderRoute: typeof AuthenticatedPatientIdPaymentMedicareInfoImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/payment/selfPay': {
      id: '/_authenticated/$patientId/payment/selfPay'
      path: '/$patientId/payment/selfPay'
      fullPath: '/$patientId/payment/selfPay'
      preLoaderRoute: typeof AuthenticatedPatientIdPaymentSelfPayImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/payment/thanks': {
      id: '/_authenticated/$patientId/payment/thanks'
      path: '/$patientId/payment/thanks'
      fullPath: '/$patientId/payment/thanks'
      preLoaderRoute: typeof AuthenticatedPatientIdPaymentThanksImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/photos/id': {
      id: '/_authenticated/$patientId/photos/id'
      path: '/$patientId/photos/id'
      fullPath: '/$patientId/photos/id'
      preLoaderRoute: typeof AuthenticatedPatientIdPhotosIdImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/photos/idConcierge': {
      id: '/_authenticated/$patientId/photos/idConcierge'
      path: '/$patientId/photos/idConcierge'
      fullPath: '/$patientId/photos/idConcierge'
      preLoaderRoute: typeof AuthenticatedPatientIdPhotosIdConciergeImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/photos/idOnly': {
      id: '/_authenticated/$patientId/photos/idOnly'
      path: '/$patientId/photos/idOnly'
      fullPath: '/$patientId/photos/idOnly'
      preLoaderRoute: typeof AuthenticatedPatientIdPhotosIdOnlyImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/photos/photoForCard': {
      id: '/_authenticated/$patientId/photos/photoForCard'
      path: '/$patientId/photos/photoForCard'
      fullPath: '/$patientId/photos/photoForCard'
      preLoaderRoute: typeof AuthenticatedPatientIdPhotosPhotoForCardImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/photos/qrInstructions': {
      id: '/_authenticated/$patientId/photos/qrInstructions'
      path: '/$patientId/photos/qrInstructions'
      fullPath: '/$patientId/photos/qrInstructions'
      preLoaderRoute: typeof AuthenticatedPatientIdPhotosQrInstructionsImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/statement/attestation': {
      id: '/_authenticated/$patientId/statement/attestation'
      path: '/$patientId/statement/attestation'
      fullPath: '/$patientId/statement/attestation'
      preLoaderRoute: typeof AuthenticatedPatientIdStatementAttestationImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/statement/finalSignatures': {
      id: '/_authenticated/$patientId/statement/finalSignatures'
      path: '/$patientId/statement/finalSignatures'
      fullPath: '/$patientId/statement/finalSignatures'
      preLoaderRoute: typeof AuthenticatedPatientIdStatementFinalSignaturesImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/statement/recording': {
      id: '/_authenticated/$patientId/statement/recording'
      path: '/$patientId/statement/recording'
      fullPath: '/$patientId/statement/recording'
      preLoaderRoute: typeof AuthenticatedPatientIdStatementRecordingImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$patientId/upload/files': {
      id: '/_authenticated/$patientId/upload/files'
      path: '/$patientId/upload/files'
      fullPath: '/$patientId/upload/files'
      preLoaderRoute: typeof AuthenticatedPatientIdUploadFilesImport
      parentRoute: typeof AuthenticatedImport
    }
  }
}

// Create and export the route tree

interface AuthenticatedRouteChildren {
  AuthenticatedHomeRoute: typeof AuthenticatedHomeRoute
  AuthenticatedWelcomeRoute: typeof AuthenticatedWelcomeRoute
  AuthenticatedPatientIdAccountAccountInfoRoute: typeof AuthenticatedPatientIdAccountAccountInfoRoute
  AuthenticatedPatientIdCaptureIdRoute: typeof AuthenticatedPatientIdCaptureIdRoute
  AuthenticatedPatientIdCardCardPreviewRoute: typeof AuthenticatedPatientIdCardCardPreviewRoute
  AuthenticatedPatientIdCardLandingPageRoute: typeof AuthenticatedPatientIdCardLandingPageRoute
  AuthenticatedPatientIdConsentFormsRoute: typeof AuthenticatedPatientIdConsentFormsRoute
  AuthenticatedPatientIdEducationInstructionalVideosRoute: typeof AuthenticatedPatientIdEducationInstructionalVideosRoute
  AuthenticatedPatientIdEducationPatientEducationRoute: typeof AuthenticatedPatientIdEducationPatientEducationRoute
  AuthenticatedPatientIdEducationTreatmentOptionRoute: typeof AuthenticatedPatientIdEducationTreatmentOptionRoute
  AuthenticatedPatientIdInfoAttorneyInfoRoute: typeof AuthenticatedPatientIdInfoAttorneyInfoRoute
  AuthenticatedPatientIdInfoCheckRoute: typeof AuthenticatedPatientIdInfoCheckRoute
  AuthenticatedPatientIdInfoDoctorInfoRoute: typeof AuthenticatedPatientIdInfoDoctorInfoRoute
  AuthenticatedPatientIdInfoHcaInfoRoute: typeof AuthenticatedPatientIdInfoHcaInfoRoute
  AuthenticatedPatientIdInfoHospitalInfoRoute: typeof AuthenticatedPatientIdInfoHospitalInfoRoute
  AuthenticatedPatientIdInfoPatientInfoRoute: typeof AuthenticatedPatientIdInfoPatientInfoRoute
  AuthenticatedPatientIdPackageConciergeRoute: typeof AuthenticatedPatientIdPackageConciergeRoute
  AuthenticatedPatientIdPackageLearnRoute: typeof AuthenticatedPatientIdPackageLearnRoute
  AuthenticatedPatientIdPackageSelectRoute: typeof AuthenticatedPatientIdPackageSelectRoute
  AuthenticatedPatientIdPaymentAobRoute: typeof AuthenticatedPatientIdPaymentAobRoute
  AuthenticatedPatientIdPaymentConfirmationRoute: typeof AuthenticatedPatientIdPaymentConfirmationRoute
  AuthenticatedPatientIdPaymentInsuranceABNRoute: typeof AuthenticatedPatientIdPaymentInsuranceABNRoute
  AuthenticatedPatientIdPaymentInsuranceInfoRoute: typeof AuthenticatedPatientIdPaymentInsuranceInfoRoute
  AuthenticatedPatientIdPaymentMedicareABNRoute: typeof AuthenticatedPatientIdPaymentMedicareABNRoute
  AuthenticatedPatientIdPaymentMedicareInfoRoute: typeof AuthenticatedPatientIdPaymentMedicareInfoRoute
  AuthenticatedPatientIdPaymentSelfPayRoute: typeof AuthenticatedPatientIdPaymentSelfPayRoute
  AuthenticatedPatientIdPaymentThanksRoute: typeof AuthenticatedPatientIdPaymentThanksRoute
  AuthenticatedPatientIdPhotosIdRoute: typeof AuthenticatedPatientIdPhotosIdRoute
  AuthenticatedPatientIdPhotosIdConciergeRoute: typeof AuthenticatedPatientIdPhotosIdConciergeRoute
  AuthenticatedPatientIdPhotosIdOnlyRoute: typeof AuthenticatedPatientIdPhotosIdOnlyRoute
  AuthenticatedPatientIdPhotosPhotoForCardRoute: typeof AuthenticatedPatientIdPhotosPhotoForCardRoute
  AuthenticatedPatientIdPhotosQrInstructionsRoute: typeof AuthenticatedPatientIdPhotosQrInstructionsRoute
  AuthenticatedPatientIdStatementAttestationRoute: typeof AuthenticatedPatientIdStatementAttestationRoute
  AuthenticatedPatientIdStatementFinalSignaturesRoute: typeof AuthenticatedPatientIdStatementFinalSignaturesRoute
  AuthenticatedPatientIdStatementRecordingRoute: typeof AuthenticatedPatientIdStatementRecordingRoute
  AuthenticatedPatientIdUploadFilesRoute: typeof AuthenticatedPatientIdUploadFilesRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedHomeRoute: AuthenticatedHomeRoute,
  AuthenticatedWelcomeRoute: AuthenticatedWelcomeRoute,
  AuthenticatedPatientIdAccountAccountInfoRoute:
    AuthenticatedPatientIdAccountAccountInfoRoute,
  AuthenticatedPatientIdCaptureIdRoute: AuthenticatedPatientIdCaptureIdRoute,
  AuthenticatedPatientIdCardCardPreviewRoute:
    AuthenticatedPatientIdCardCardPreviewRoute,
  AuthenticatedPatientIdCardLandingPageRoute:
    AuthenticatedPatientIdCardLandingPageRoute,
  AuthenticatedPatientIdConsentFormsRoute:
    AuthenticatedPatientIdConsentFormsRoute,
  AuthenticatedPatientIdEducationInstructionalVideosRoute:
    AuthenticatedPatientIdEducationInstructionalVideosRoute,
  AuthenticatedPatientIdEducationPatientEducationRoute:
    AuthenticatedPatientIdEducationPatientEducationRoute,
  AuthenticatedPatientIdEducationTreatmentOptionRoute:
    AuthenticatedPatientIdEducationTreatmentOptionRoute,
  AuthenticatedPatientIdInfoAttorneyInfoRoute:
    AuthenticatedPatientIdInfoAttorneyInfoRoute,
  AuthenticatedPatientIdInfoCheckRoute: AuthenticatedPatientIdInfoCheckRoute,
  AuthenticatedPatientIdInfoDoctorInfoRoute:
    AuthenticatedPatientIdInfoDoctorInfoRoute,
  AuthenticatedPatientIdInfoHcaInfoRoute:
    AuthenticatedPatientIdInfoHcaInfoRoute,
  AuthenticatedPatientIdInfoHospitalInfoRoute:
    AuthenticatedPatientIdInfoHospitalInfoRoute,
  AuthenticatedPatientIdInfoPatientInfoRoute:
    AuthenticatedPatientIdInfoPatientInfoRoute,
  AuthenticatedPatientIdPackageConciergeRoute:
    AuthenticatedPatientIdPackageConciergeRoute,
  AuthenticatedPatientIdPackageLearnRoute:
    AuthenticatedPatientIdPackageLearnRoute,
  AuthenticatedPatientIdPackageSelectRoute:
    AuthenticatedPatientIdPackageSelectRoute,
  AuthenticatedPatientIdPaymentAobRoute: AuthenticatedPatientIdPaymentAobRoute,
  AuthenticatedPatientIdPaymentConfirmationRoute:
    AuthenticatedPatientIdPaymentConfirmationRoute,
  AuthenticatedPatientIdPaymentInsuranceABNRoute:
    AuthenticatedPatientIdPaymentInsuranceABNRoute,
  AuthenticatedPatientIdPaymentInsuranceInfoRoute:
    AuthenticatedPatientIdPaymentInsuranceInfoRoute,
  AuthenticatedPatientIdPaymentMedicareABNRoute:
    AuthenticatedPatientIdPaymentMedicareABNRoute,
  AuthenticatedPatientIdPaymentMedicareInfoRoute:
    AuthenticatedPatientIdPaymentMedicareInfoRoute,
  AuthenticatedPatientIdPaymentSelfPayRoute:
    AuthenticatedPatientIdPaymentSelfPayRoute,
  AuthenticatedPatientIdPaymentThanksRoute:
    AuthenticatedPatientIdPaymentThanksRoute,
  AuthenticatedPatientIdPhotosIdRoute: AuthenticatedPatientIdPhotosIdRoute,
  AuthenticatedPatientIdPhotosIdConciergeRoute:
    AuthenticatedPatientIdPhotosIdConciergeRoute,
  AuthenticatedPatientIdPhotosIdOnlyRoute:
    AuthenticatedPatientIdPhotosIdOnlyRoute,
  AuthenticatedPatientIdPhotosPhotoForCardRoute:
    AuthenticatedPatientIdPhotosPhotoForCardRoute,
  AuthenticatedPatientIdPhotosQrInstructionsRoute:
    AuthenticatedPatientIdPhotosQrInstructionsRoute,
  AuthenticatedPatientIdStatementAttestationRoute:
    AuthenticatedPatientIdStatementAttestationRoute,
  AuthenticatedPatientIdStatementFinalSignaturesRoute:
    AuthenticatedPatientIdStatementFinalSignaturesRoute,
  AuthenticatedPatientIdStatementRecordingRoute:
    AuthenticatedPatientIdStatementRecordingRoute,
  AuthenticatedPatientIdUploadFilesRoute:
    AuthenticatedPatientIdUploadFilesRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof AuthenticatedRouteWithChildren
  '/concierge': typeof ConciergeRoute
  '/enroll': typeof EnrollRoute
  '/login': typeof LoginRoute
  '/passwordless': typeof PasswordlessRoute
  '/testErrors': typeof TestErrorsRoute
  '/home': typeof AuthenticatedHomeRoute
  '/welcome': typeof AuthenticatedWelcomeRoute
  '/$patientId/account/accountInfo': typeof AuthenticatedPatientIdAccountAccountInfoRoute
  '/$patientId/capture/id': typeof AuthenticatedPatientIdCaptureIdRoute
  '/$patientId/card/cardPreview': typeof AuthenticatedPatientIdCardCardPreviewRoute
  '/$patientId/card/landingPage': typeof AuthenticatedPatientIdCardLandingPageRoute
  '/$patientId/consent/forms': typeof AuthenticatedPatientIdConsentFormsRoute
  '/$patientId/education/instructionalVideos': typeof AuthenticatedPatientIdEducationInstructionalVideosRoute
  '/$patientId/education/patientEducation': typeof AuthenticatedPatientIdEducationPatientEducationRoute
  '/$patientId/education/treatmentOption': typeof AuthenticatedPatientIdEducationTreatmentOptionRoute
  '/$patientId/info/attorneyInfo': typeof AuthenticatedPatientIdInfoAttorneyInfoRoute
  '/$patientId/info/check': typeof AuthenticatedPatientIdInfoCheckRoute
  '/$patientId/info/doctorInfo': typeof AuthenticatedPatientIdInfoDoctorInfoRoute
  '/$patientId/info/hcaInfo': typeof AuthenticatedPatientIdInfoHcaInfoRoute
  '/$patientId/info/hospitalInfo': typeof AuthenticatedPatientIdInfoHospitalInfoRoute
  '/$patientId/info/patientInfo': typeof AuthenticatedPatientIdInfoPatientInfoRoute
  '/$patientId/package/concierge': typeof AuthenticatedPatientIdPackageConciergeRoute
  '/$patientId/package/learn': typeof AuthenticatedPatientIdPackageLearnRoute
  '/$patientId/package/select': typeof AuthenticatedPatientIdPackageSelectRoute
  '/$patientId/payment/aob': typeof AuthenticatedPatientIdPaymentAobRoute
  '/$patientId/payment/confirmation': typeof AuthenticatedPatientIdPaymentConfirmationRoute
  '/$patientId/payment/insuranceABN': typeof AuthenticatedPatientIdPaymentInsuranceABNRoute
  '/$patientId/payment/insuranceInfo': typeof AuthenticatedPatientIdPaymentInsuranceInfoRoute
  '/$patientId/payment/medicareABN': typeof AuthenticatedPatientIdPaymentMedicareABNRoute
  '/$patientId/payment/medicareInfo': typeof AuthenticatedPatientIdPaymentMedicareInfoRoute
  '/$patientId/payment/selfPay': typeof AuthenticatedPatientIdPaymentSelfPayRoute
  '/$patientId/payment/thanks': typeof AuthenticatedPatientIdPaymentThanksRoute
  '/$patientId/photos/id': typeof AuthenticatedPatientIdPhotosIdRoute
  '/$patientId/photos/idConcierge': typeof AuthenticatedPatientIdPhotosIdConciergeRoute
  '/$patientId/photos/idOnly': typeof AuthenticatedPatientIdPhotosIdOnlyRoute
  '/$patientId/photos/photoForCard': typeof AuthenticatedPatientIdPhotosPhotoForCardRoute
  '/$patientId/photos/qrInstructions': typeof AuthenticatedPatientIdPhotosQrInstructionsRoute
  '/$patientId/statement/attestation': typeof AuthenticatedPatientIdStatementAttestationRoute
  '/$patientId/statement/finalSignatures': typeof AuthenticatedPatientIdStatementFinalSignaturesRoute
  '/$patientId/statement/recording': typeof AuthenticatedPatientIdStatementRecordingRoute
  '/$patientId/upload/files': typeof AuthenticatedPatientIdUploadFilesRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof AuthenticatedRouteWithChildren
  '/concierge': typeof ConciergeRoute
  '/enroll': typeof EnrollRoute
  '/login': typeof LoginRoute
  '/passwordless': typeof PasswordlessRoute
  '/testErrors': typeof TestErrorsRoute
  '/home': typeof AuthenticatedHomeRoute
  '/welcome': typeof AuthenticatedWelcomeRoute
  '/$patientId/account/accountInfo': typeof AuthenticatedPatientIdAccountAccountInfoRoute
  '/$patientId/capture/id': typeof AuthenticatedPatientIdCaptureIdRoute
  '/$patientId/card/cardPreview': typeof AuthenticatedPatientIdCardCardPreviewRoute
  '/$patientId/card/landingPage': typeof AuthenticatedPatientIdCardLandingPageRoute
  '/$patientId/consent/forms': typeof AuthenticatedPatientIdConsentFormsRoute
  '/$patientId/education/instructionalVideos': typeof AuthenticatedPatientIdEducationInstructionalVideosRoute
  '/$patientId/education/patientEducation': typeof AuthenticatedPatientIdEducationPatientEducationRoute
  '/$patientId/education/treatmentOption': typeof AuthenticatedPatientIdEducationTreatmentOptionRoute
  '/$patientId/info/attorneyInfo': typeof AuthenticatedPatientIdInfoAttorneyInfoRoute
  '/$patientId/info/check': typeof AuthenticatedPatientIdInfoCheckRoute
  '/$patientId/info/doctorInfo': typeof AuthenticatedPatientIdInfoDoctorInfoRoute
  '/$patientId/info/hcaInfo': typeof AuthenticatedPatientIdInfoHcaInfoRoute
  '/$patientId/info/hospitalInfo': typeof AuthenticatedPatientIdInfoHospitalInfoRoute
  '/$patientId/info/patientInfo': typeof AuthenticatedPatientIdInfoPatientInfoRoute
  '/$patientId/package/concierge': typeof AuthenticatedPatientIdPackageConciergeRoute
  '/$patientId/package/learn': typeof AuthenticatedPatientIdPackageLearnRoute
  '/$patientId/package/select': typeof AuthenticatedPatientIdPackageSelectRoute
  '/$patientId/payment/aob': typeof AuthenticatedPatientIdPaymentAobRoute
  '/$patientId/payment/confirmation': typeof AuthenticatedPatientIdPaymentConfirmationRoute
  '/$patientId/payment/insuranceABN': typeof AuthenticatedPatientIdPaymentInsuranceABNRoute
  '/$patientId/payment/insuranceInfo': typeof AuthenticatedPatientIdPaymentInsuranceInfoRoute
  '/$patientId/payment/medicareABN': typeof AuthenticatedPatientIdPaymentMedicareABNRoute
  '/$patientId/payment/medicareInfo': typeof AuthenticatedPatientIdPaymentMedicareInfoRoute
  '/$patientId/payment/selfPay': typeof AuthenticatedPatientIdPaymentSelfPayRoute
  '/$patientId/payment/thanks': typeof AuthenticatedPatientIdPaymentThanksRoute
  '/$patientId/photos/id': typeof AuthenticatedPatientIdPhotosIdRoute
  '/$patientId/photos/idConcierge': typeof AuthenticatedPatientIdPhotosIdConciergeRoute
  '/$patientId/photos/idOnly': typeof AuthenticatedPatientIdPhotosIdOnlyRoute
  '/$patientId/photos/photoForCard': typeof AuthenticatedPatientIdPhotosPhotoForCardRoute
  '/$patientId/photos/qrInstructions': typeof AuthenticatedPatientIdPhotosQrInstructionsRoute
  '/$patientId/statement/attestation': typeof AuthenticatedPatientIdStatementAttestationRoute
  '/$patientId/statement/finalSignatures': typeof AuthenticatedPatientIdStatementFinalSignaturesRoute
  '/$patientId/statement/recording': typeof AuthenticatedPatientIdStatementRecordingRoute
  '/$patientId/upload/files': typeof AuthenticatedPatientIdUploadFilesRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/concierge': typeof ConciergeRoute
  '/enroll': typeof EnrollRoute
  '/login': typeof LoginRoute
  '/passwordless': typeof PasswordlessRoute
  '/testErrors': typeof TestErrorsRoute
  '/_authenticated/home': typeof AuthenticatedHomeRoute
  '/_authenticated/welcome': typeof AuthenticatedWelcomeRoute
  '/_authenticated/$patientId/account/accountInfo': typeof AuthenticatedPatientIdAccountAccountInfoRoute
  '/_authenticated/$patientId/capture/id': typeof AuthenticatedPatientIdCaptureIdRoute
  '/_authenticated/$patientId/card/cardPreview': typeof AuthenticatedPatientIdCardCardPreviewRoute
  '/_authenticated/$patientId/card/landingPage': typeof AuthenticatedPatientIdCardLandingPageRoute
  '/_authenticated/$patientId/consent/forms': typeof AuthenticatedPatientIdConsentFormsRoute
  '/_authenticated/$patientId/education/instructionalVideos': typeof AuthenticatedPatientIdEducationInstructionalVideosRoute
  '/_authenticated/$patientId/education/patientEducation': typeof AuthenticatedPatientIdEducationPatientEducationRoute
  '/_authenticated/$patientId/education/treatmentOption': typeof AuthenticatedPatientIdEducationTreatmentOptionRoute
  '/_authenticated/$patientId/info/attorneyInfo': typeof AuthenticatedPatientIdInfoAttorneyInfoRoute
  '/_authenticated/$patientId/info/check': typeof AuthenticatedPatientIdInfoCheckRoute
  '/_authenticated/$patientId/info/doctorInfo': typeof AuthenticatedPatientIdInfoDoctorInfoRoute
  '/_authenticated/$patientId/info/hcaInfo': typeof AuthenticatedPatientIdInfoHcaInfoRoute
  '/_authenticated/$patientId/info/hospitalInfo': typeof AuthenticatedPatientIdInfoHospitalInfoRoute
  '/_authenticated/$patientId/info/patientInfo': typeof AuthenticatedPatientIdInfoPatientInfoRoute
  '/_authenticated/$patientId/package/concierge': typeof AuthenticatedPatientIdPackageConciergeRoute
  '/_authenticated/$patientId/package/learn': typeof AuthenticatedPatientIdPackageLearnRoute
  '/_authenticated/$patientId/package/select': typeof AuthenticatedPatientIdPackageSelectRoute
  '/_authenticated/$patientId/payment/aob': typeof AuthenticatedPatientIdPaymentAobRoute
  '/_authenticated/$patientId/payment/confirmation': typeof AuthenticatedPatientIdPaymentConfirmationRoute
  '/_authenticated/$patientId/payment/insuranceABN': typeof AuthenticatedPatientIdPaymentInsuranceABNRoute
  '/_authenticated/$patientId/payment/insuranceInfo': typeof AuthenticatedPatientIdPaymentInsuranceInfoRoute
  '/_authenticated/$patientId/payment/medicareABN': typeof AuthenticatedPatientIdPaymentMedicareABNRoute
  '/_authenticated/$patientId/payment/medicareInfo': typeof AuthenticatedPatientIdPaymentMedicareInfoRoute
  '/_authenticated/$patientId/payment/selfPay': typeof AuthenticatedPatientIdPaymentSelfPayRoute
  '/_authenticated/$patientId/payment/thanks': typeof AuthenticatedPatientIdPaymentThanksRoute
  '/_authenticated/$patientId/photos/id': typeof AuthenticatedPatientIdPhotosIdRoute
  '/_authenticated/$patientId/photos/idConcierge': typeof AuthenticatedPatientIdPhotosIdConciergeRoute
  '/_authenticated/$patientId/photos/idOnly': typeof AuthenticatedPatientIdPhotosIdOnlyRoute
  '/_authenticated/$patientId/photos/photoForCard': typeof AuthenticatedPatientIdPhotosPhotoForCardRoute
  '/_authenticated/$patientId/photos/qrInstructions': typeof AuthenticatedPatientIdPhotosQrInstructionsRoute
  '/_authenticated/$patientId/statement/attestation': typeof AuthenticatedPatientIdStatementAttestationRoute
  '/_authenticated/$patientId/statement/finalSignatures': typeof AuthenticatedPatientIdStatementFinalSignaturesRoute
  '/_authenticated/$patientId/statement/recording': typeof AuthenticatedPatientIdStatementRecordingRoute
  '/_authenticated/$patientId/upload/files': typeof AuthenticatedPatientIdUploadFilesRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/concierge'
    | '/enroll'
    | '/login'
    | '/passwordless'
    | '/testErrors'
    | '/home'
    | '/welcome'
    | '/$patientId/account/accountInfo'
    | '/$patientId/capture/id'
    | '/$patientId/card/cardPreview'
    | '/$patientId/card/landingPage'
    | '/$patientId/consent/forms'
    | '/$patientId/education/instructionalVideos'
    | '/$patientId/education/patientEducation'
    | '/$patientId/education/treatmentOption'
    | '/$patientId/info/attorneyInfo'
    | '/$patientId/info/check'
    | '/$patientId/info/doctorInfo'
    | '/$patientId/info/hcaInfo'
    | '/$patientId/info/hospitalInfo'
    | '/$patientId/info/patientInfo'
    | '/$patientId/package/concierge'
    | '/$patientId/package/learn'
    | '/$patientId/package/select'
    | '/$patientId/payment/aob'
    | '/$patientId/payment/confirmation'
    | '/$patientId/payment/insuranceABN'
    | '/$patientId/payment/insuranceInfo'
    | '/$patientId/payment/medicareABN'
    | '/$patientId/payment/medicareInfo'
    | '/$patientId/payment/selfPay'
    | '/$patientId/payment/thanks'
    | '/$patientId/photos/id'
    | '/$patientId/photos/idConcierge'
    | '/$patientId/photos/idOnly'
    | '/$patientId/photos/photoForCard'
    | '/$patientId/photos/qrInstructions'
    | '/$patientId/statement/attestation'
    | '/$patientId/statement/finalSignatures'
    | '/$patientId/statement/recording'
    | '/$patientId/upload/files'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/concierge'
    | '/enroll'
    | '/login'
    | '/passwordless'
    | '/testErrors'
    | '/home'
    | '/welcome'
    | '/$patientId/account/accountInfo'
    | '/$patientId/capture/id'
    | '/$patientId/card/cardPreview'
    | '/$patientId/card/landingPage'
    | '/$patientId/consent/forms'
    | '/$patientId/education/instructionalVideos'
    | '/$patientId/education/patientEducation'
    | '/$patientId/education/treatmentOption'
    | '/$patientId/info/attorneyInfo'
    | '/$patientId/info/check'
    | '/$patientId/info/doctorInfo'
    | '/$patientId/info/hcaInfo'
    | '/$patientId/info/hospitalInfo'
    | '/$patientId/info/patientInfo'
    | '/$patientId/package/concierge'
    | '/$patientId/package/learn'
    | '/$patientId/package/select'
    | '/$patientId/payment/aob'
    | '/$patientId/payment/confirmation'
    | '/$patientId/payment/insuranceABN'
    | '/$patientId/payment/insuranceInfo'
    | '/$patientId/payment/medicareABN'
    | '/$patientId/payment/medicareInfo'
    | '/$patientId/payment/selfPay'
    | '/$patientId/payment/thanks'
    | '/$patientId/photos/id'
    | '/$patientId/photos/idConcierge'
    | '/$patientId/photos/idOnly'
    | '/$patientId/photos/photoForCard'
    | '/$patientId/photos/qrInstructions'
    | '/$patientId/statement/attestation'
    | '/$patientId/statement/finalSignatures'
    | '/$patientId/statement/recording'
    | '/$patientId/upload/files'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/concierge'
    | '/enroll'
    | '/login'
    | '/passwordless'
    | '/testErrors'
    | '/_authenticated/home'
    | '/_authenticated/welcome'
    | '/_authenticated/$patientId/account/accountInfo'
    | '/_authenticated/$patientId/capture/id'
    | '/_authenticated/$patientId/card/cardPreview'
    | '/_authenticated/$patientId/card/landingPage'
    | '/_authenticated/$patientId/consent/forms'
    | '/_authenticated/$patientId/education/instructionalVideos'
    | '/_authenticated/$patientId/education/patientEducation'
    | '/_authenticated/$patientId/education/treatmentOption'
    | '/_authenticated/$patientId/info/attorneyInfo'
    | '/_authenticated/$patientId/info/check'
    | '/_authenticated/$patientId/info/doctorInfo'
    | '/_authenticated/$patientId/info/hcaInfo'
    | '/_authenticated/$patientId/info/hospitalInfo'
    | '/_authenticated/$patientId/info/patientInfo'
    | '/_authenticated/$patientId/package/concierge'
    | '/_authenticated/$patientId/package/learn'
    | '/_authenticated/$patientId/package/select'
    | '/_authenticated/$patientId/payment/aob'
    | '/_authenticated/$patientId/payment/confirmation'
    | '/_authenticated/$patientId/payment/insuranceABN'
    | '/_authenticated/$patientId/payment/insuranceInfo'
    | '/_authenticated/$patientId/payment/medicareABN'
    | '/_authenticated/$patientId/payment/medicareInfo'
    | '/_authenticated/$patientId/payment/selfPay'
    | '/_authenticated/$patientId/payment/thanks'
    | '/_authenticated/$patientId/photos/id'
    | '/_authenticated/$patientId/photos/idConcierge'
    | '/_authenticated/$patientId/photos/idOnly'
    | '/_authenticated/$patientId/photos/photoForCard'
    | '/_authenticated/$patientId/photos/qrInstructions'
    | '/_authenticated/$patientId/statement/attestation'
    | '/_authenticated/$patientId/statement/finalSignatures'
    | '/_authenticated/$patientId/statement/recording'
    | '/_authenticated/$patientId/upload/files'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ConciergeRoute: typeof ConciergeRoute
  EnrollRoute: typeof EnrollRoute
  LoginRoute: typeof LoginRoute
  PasswordlessRoute: typeof PasswordlessRoute
  TestErrorsRoute: typeof TestErrorsRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ConciergeRoute: ConciergeRoute,
  EnrollRoute: EnrollRoute,
  LoginRoute: LoginRoute,
  PasswordlessRoute: PasswordlessRoute,
  TestErrorsRoute: TestErrorsRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_authenticated",
        "/concierge",
        "/enroll",
        "/login",
        "/passwordless",
        "/testErrors"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_authenticated": {
      "filePath": "_authenticated.tsx",
      "children": [
        "/_authenticated/home",
        "/_authenticated/welcome",
        "/_authenticated/$patientId/account/accountInfo",
        "/_authenticated/$patientId/capture/id",
        "/_authenticated/$patientId/card/cardPreview",
        "/_authenticated/$patientId/card/landingPage",
        "/_authenticated/$patientId/consent/forms",
        "/_authenticated/$patientId/education/instructionalVideos",
        "/_authenticated/$patientId/education/patientEducation",
        "/_authenticated/$patientId/education/treatmentOption",
        "/_authenticated/$patientId/info/attorneyInfo",
        "/_authenticated/$patientId/info/check",
        "/_authenticated/$patientId/info/doctorInfo",
        "/_authenticated/$patientId/info/hcaInfo",
        "/_authenticated/$patientId/info/hospitalInfo",
        "/_authenticated/$patientId/info/patientInfo",
        "/_authenticated/$patientId/package/concierge",
        "/_authenticated/$patientId/package/learn",
        "/_authenticated/$patientId/package/select",
        "/_authenticated/$patientId/payment/aob",
        "/_authenticated/$patientId/payment/confirmation",
        "/_authenticated/$patientId/payment/insuranceABN",
        "/_authenticated/$patientId/payment/insuranceInfo",
        "/_authenticated/$patientId/payment/medicareABN",
        "/_authenticated/$patientId/payment/medicareInfo",
        "/_authenticated/$patientId/payment/selfPay",
        "/_authenticated/$patientId/payment/thanks",
        "/_authenticated/$patientId/photos/id",
        "/_authenticated/$patientId/photos/idConcierge",
        "/_authenticated/$patientId/photos/idOnly",
        "/_authenticated/$patientId/photos/photoForCard",
        "/_authenticated/$patientId/photos/qrInstructions",
        "/_authenticated/$patientId/statement/attestation",
        "/_authenticated/$patientId/statement/finalSignatures",
        "/_authenticated/$patientId/statement/recording",
        "/_authenticated/$patientId/upload/files"
      ]
    },
    "/concierge": {
      "filePath": "concierge.tsx"
    },
    "/enroll": {
      "filePath": "enroll.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/passwordless": {
      "filePath": "passwordless.tsx"
    },
    "/testErrors": {
      "filePath": "testErrors.tsx"
    },
    "/_authenticated/home": {
      "filePath": "_authenticated/home.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/welcome": {
      "filePath": "_authenticated/welcome.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/account/accountInfo": {
      "filePath": "_authenticated/$patientId/account/accountInfo.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/capture/id": {
      "filePath": "_authenticated/$patientId/capture/id.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/card/cardPreview": {
      "filePath": "_authenticated/$patientId/card/cardPreview.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/card/landingPage": {
      "filePath": "_authenticated/$patientId/card/landingPage.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/consent/forms": {
      "filePath": "_authenticated/$patientId/consent/forms.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/education/instructionalVideos": {
      "filePath": "_authenticated/$patientId/education/instructionalVideos.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/education/patientEducation": {
      "filePath": "_authenticated/$patientId/education/patientEducation.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/education/treatmentOption": {
      "filePath": "_authenticated/$patientId/education/treatmentOption.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/info/attorneyInfo": {
      "filePath": "_authenticated/$patientId/info/attorneyInfo.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/info/check": {
      "filePath": "_authenticated/$patientId/info/check.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/info/doctorInfo": {
      "filePath": "_authenticated/$patientId/info/doctorInfo.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/info/hcaInfo": {
      "filePath": "_authenticated/$patientId/info/hcaInfo.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/info/hospitalInfo": {
      "filePath": "_authenticated/$patientId/info/hospitalInfo.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/info/patientInfo": {
      "filePath": "_authenticated/$patientId/info/patientInfo.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/package/concierge": {
      "filePath": "_authenticated/$patientId/package/concierge.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/package/learn": {
      "filePath": "_authenticated/$patientId/package/learn.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/package/select": {
      "filePath": "_authenticated/$patientId/package/select.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/payment/aob": {
      "filePath": "_authenticated/$patientId/payment/aob.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/payment/confirmation": {
      "filePath": "_authenticated/$patientId/payment/confirmation.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/payment/insuranceABN": {
      "filePath": "_authenticated/$patientId/payment/insuranceABN.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/payment/insuranceInfo": {
      "filePath": "_authenticated/$patientId/payment/insuranceInfo.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/payment/medicareABN": {
      "filePath": "_authenticated/$patientId/payment/medicareABN.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/payment/medicareInfo": {
      "filePath": "_authenticated/$patientId/payment/medicareInfo.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/payment/selfPay": {
      "filePath": "_authenticated/$patientId/payment/selfPay.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/payment/thanks": {
      "filePath": "_authenticated/$patientId/payment/thanks.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/photos/id": {
      "filePath": "_authenticated/$patientId/photos/id.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/photos/idConcierge": {
      "filePath": "_authenticated/$patientId/photos/idConcierge.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/photos/idOnly": {
      "filePath": "_authenticated/$patientId/photos/idOnly.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/photos/photoForCard": {
      "filePath": "_authenticated/$patientId/photos/photoForCard.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/photos/qrInstructions": {
      "filePath": "_authenticated/$patientId/photos/qrInstructions.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/statement/attestation": {
      "filePath": "_authenticated/$patientId/statement/attestation.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/statement/finalSignatures": {
      "filePath": "_authenticated/$patientId/statement/finalSignatures.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/statement/recording": {
      "filePath": "_authenticated/$patientId/statement/recording.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/$patientId/upload/files": {
      "filePath": "_authenticated/$patientId/upload/files.tsx",
      "parent": "/_authenticated"
    }
  }
}
ROUTE_MANIFEST_END */
